import {
	LoadingSkeleton,
	LoadingSkeletonItem,
} from 'components/LoadingSkeleton';
import { StockStatus } from 'components/Stock';
import { useFeatureToggle } from 'hooks';
import type { VariantStockResponse } from 'models/api';

interface Props {
	isLoading: boolean;
	stock: VariantStockResponse | undefined;
}

export default function StockInformation({ isLoading, stock }: Props) {
	const { storesEnabled } = useFeatureToggle();

	return (
		<>
			{isLoading && (
				<LoadingSkeleton>
					<LoadingSkeletonItem height="text" width="10rem" />
					<LoadingSkeletonItem height="text" width="10rem" className="mt-1" />
				</LoadingSkeleton>
			)}
			{!isLoading && stock && (
				<>
					<StockStatus
						size="sm"
						inStock={stock.webStock.inStock}
						text={stock.webStock.text.specific}
					/>
					{storesEnabled && (
						<StockStatus
							size="sm"
							inStock={stock.storeStock.inStock}
							text={stock.storeStock.text.specific}
							className="mt-1"
						/>
					)}
				</>
			)}
		</>
	);
}
StockInformation.displayName = 'VariantPicker_StockInformation';
